import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from '../models';
import { ENVIRONMENTS } from '../tokens';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  readonly environments: IEnvironment;

  constructor(@Inject(ENVIRONMENTS) environments: IEnvironment) {
    this.environments = environments;
  }
}
